import { render, staticRenderFns } from "./ArquivosWindowLI.vue?vue&type=template&id=ba0ec23a&scoped=true&"
import script from "./ArquivosWindowLI.vue?vue&type=script&lang=js&"
export * from "./ArquivosWindowLI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0ec23a",
  null
  
)

export default component.exports